import qs from "qs";
import { request } from "../http/http";

const getMeetingList = params => {
  return request({
    url: "/web/conferencePage",
    method: "get",
    params
  });
};

const getRecentMeetingList = params => {
  const q = qs.stringify(params, { arrayFormat: "repeat", allowDots: true });
  return request({
    url: "/web/conferencePage?" + q,
    method: "get"
  });
};

const getMeetingDetail = id => {
  return request({
    url: `/web/meeting/${id}`,
    method: "get"
  });
};

const getCategoryList = () => {
  return request({
    url: "/dictionaries?type=CONFERENCE_CATEGORY",
    method: "get"
  });
};

const getShareImage = (url, data) => {
  return request({
    url,
    method: "post",
    data
  });
};

export {
  getMeetingList,
  getRecentMeetingList,
  getMeetingDetail,
  getCategoryList,
  getShareImage
};



// WEBPACK FOOTER //
// ./src/services/meeting.js